export default "__VITE_ASSET__BLem0H9D__"